import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import SftpWriterForm from '../forms/sftp-writer-form';
import { sftpWriterValidationSchema } from '../schema/sftpWriter.js';

export default function SftpWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'SFTP Writer Node Details',
        altText: 'SFTP Writer Node',
        defaultLabel: 'SFTP Writer Node',
      }}
    >
      <CommonNode FormComponent={SftpWriterForm} schemaResolver={sftpWriterValidationSchema} />
    </NodeProvider>
  );
}
